// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { CatalogPerson } from './catalogPerson.zod.ts';

export const Freshness = zod.object({
  "last_confirmed_at": zod.union([zod.iso.datetime({"offset":true}),zod.null()]),
  "last_confirmed_by": zod.union([CatalogPerson,zod.null()]),
  "stale": zod.boolean()
});

export type Freshness = zod.input<typeof Freshness>;
export type FreshnessOutput = zod.output<typeof Freshness>;
